import { TransactionSearchDTO } from "common/dto";
import { FormValidations } from "common/hooks";
import { genericDateRangeValidation } from "common/utils";

type Options = { [key: string]: string };

const transactionFormValidations = (lang: Options): FormValidations<TransactionSearchDTO> => [
  (values) => genericDateRangeValidation(values, 'transactionDate', lang.msgInputValidPeriodStartAndEnd),
  (values) => genericDateRangeValidation(values, 'regDate', lang.msgInputValidPeriodStartAndEnd),
]

export default transactionFormValidations;